import i18n from "@cirrus/legacy/features/core/shared/utils/i18n.es6"
import { makeStyles, PopupMenu } from "@cirrus/ui-kit"
import T from "prop-types"
import { createElement as h } from "react"
import { useSelector } from "react-redux"

import { accountActions } from "../../../shared/api/cirrus-internal/author/index"
import { CurrentUserModel } from "../model/index.js"

import { AvatarIcon } from "./avatars.js"

const useStyles = makeStyles(({ skinObject: { header } }) => ({
  "@media print": {
    button: {
      display: "none",
    },
  },
  button: {
    "&.MuiButton-root": {
      "& > span:nth-child(1)": {
        width: "50px",
      },
      "& > span:nth-child(2)": {
        marginLeft: "-10px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "140px",
      },
      color: "yellow",
    },
    color: `${(header && header.main && header.main.color) || "#f2f2f2"} !important`,
    width: "232px",
  },
}))

export const MainMenu = ({ disabled, additionalItems = [] }) => {
  const userName = useSelector(CurrentUserModel.state.name)
  const { button } = useStyles()

  return h(PopupMenu, {
    buttonProps: {
      className: button,
      disabled,
      height: "100%",
      label:
        sessionStorage.getItem("Cirrus_Delivery_Mode") === "Anonymous"
          ? i18n("General:Anonymous")
          : userName,
      startIcon: h(AvatarIcon, { className: "doNotLockByOverlay" }),
      style: { fontWeight: 600 },
      variant: "text",
      width: "auto",
      id: "account-btn"
    },
    disableScrollLock: true,
    list: [
      ...additionalItems,
      {
        onClick: async () => {
          await accountActions.logoutPOST()
          App.vent.trigger("logoff")
        },
        title: i18n("General:Logout"),
      },
    ],
    menuGap: 45,
    withoutArrow: true,
  })
}

MainMenu.propTypes = {
  additionalItems: PopupMenu.propTypes.list,
  disabled: T.bool,
}
